<script setup>
import SettingsPage from '@/components/SettingsPage.vue';

</script>

<template>
  <Suspense>
    <SettingsPage />
  </Suspense>
</template>
